import React from 'react';
import AriaModal from 'react-aria-modal';
import PropTypes from 'prop-types';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { Button } from '../../elements/ActionElement';
import { sharedOverlayProps, overlayControllerProps } from './_allowedPropTypes';

const OverlayContext = React.createContext();

class Overlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDirtyForm: false,
      shouldOverlayOpen: props.isOpen || false
    };

    this.toggleOverlay = this.toggleOverlay.bind(this);
    this.setOverlayDirtyState = this.setOverlayDirtyState.bind(this);
  }

  setOverlayDirtyState(hasDirtyForm) {
    const { hasDirtyForm: hasHadDirtyForm } = this.state;

    if (hasHadDirtyForm !== hasDirtyForm) {
      this.setState({ hasDirtyForm });
    }
  }

  toggleOverlay(shouldOverlayOpen, callback) {
    const {
      props: {
        ignoreAbandoningDirtyForm,
        translate
      },
      state: {
        hasDirtyForm
      }
    } = this;

    const shouldRequireConfirmation = !shouldOverlayOpen && !ignoreAbandoningDirtyForm && hasDirtyForm;

    const isChangeConfirmed = shouldRequireConfirmation ? window.confirm(translate('prompt-leavingDirtyForm')) : true;
    if (isChangeConfirmed) {
      this.setState({ shouldOverlayOpen });
    }

    if (typeof (callback) === 'function') {
      callback();
    }
  }

  render() {
    const {
      props: {
        overlayTitle,
        focusFirstChild,
        verticallyCenter,
        dialogSize = 'normal',
        trigger: {
          buttonContent: triggerContent,
          buttonIconName: triggerIcon,
          buttonProps: triggerProps
        },
        closer: {
          buttonContent: closerContent,
          buttonIconName: closerIcon,
          buttonProps: closerProps = {}
        } = {},
        classNames = [],
        noMinHeight,
        noPadding,
        children
      },
      state,
      toggleOverlay,
      setOverlayDirtyState
    } = this;

    const { shouldOverlayOpen } = state;
    const { onClick: triggerAction } = triggerProps;
    const { onClick: closerAction } = closerProps;
    const hasCloserButton = (closerIcon || closerContent || Object.keys(closerProps).length > 0);
    const closerButtonClasses = [
      'button-closer',
      'itemgap-top'
    ];

    delete triggerProps.buttonContent;
    delete closerProps.buttonContent;

    classNames.push(`dialog-size-${dialogSize}`);

    if (noMinHeight) {
      classNames.push('no-min-height');
    }

    if (noPadding) {
      classNames.push('no-padding');
      closerButtonClasses.push('itemgap-bottom');
    }

    return (
      <OverlayContext.Provider value={{
        state,
        setOverlayDirtyState,
        openOverlay: callback => toggleOverlay(true, callback),
        closeOverlay: callback => toggleOverlay(false, callback)
      }}
      >
        <Button
          onClick={() => toggleOverlay(true, triggerAction)}
          iconName={triggerIcon}
          disabled={false}
          {...triggerProps}
        >
          {triggerContent}
        </Button>

        <AriaModal
          titleText={overlayTitle}
          mounted={shouldOverlayOpen}
          onExit={() => toggleOverlay(false)}
          verticallyCenter={verticallyCenter}
          focusDialog={!focusFirstChild}
          getApplicationNode={() => document.getElementById('app')}
          dialogClass={classNames.join(' ')}
          scrollDisabled
        >
          <div className='aria-modal-main'>
            <OverlayContext.Consumer>
              {children}
            </OverlayContext.Consumer>
          </div>

          {!hasCloserButton ? null : (
            <Button
              onClick={() => toggleOverlay(false, closerAction)}
              buttonColor='secondary'
              className={closerButtonClasses.join(' ')}
              iconName={closerIcon}
              disabled={false}
              isFullWidth
              {...closerProps}
            >
              {closerContent}
            </Button>
          )}
        </AriaModal>
      </OverlayContext.Provider>
    );
  }
}


Overlay.propTypes = {
  ...sharedOverlayProps,
  isOpen: PropTypes.bool,
  trigger: PropTypes.shape(overlayControllerProps).isRequired,
  closer: PropTypes.shape(overlayControllerProps),
  ignoreAbandoningDirtyForm: PropTypes.bool,
  noMinHeight: PropTypes.bool,
  verticallyCenter: PropTypes.bool
};


export default withLocalization(Overlay, 'general/messages');